import UserGroup from "@/modules/user_group/components/UserGroup";
import UserGroupForm from "@/modules/user_group/components/UserGroupForm";

export default [
    {
        path: "/user-group",
        name: "UserGroup",
        component: UserGroup,
    },
    {
        path: "/user-group/form",
        name: "UserGroupForm",
        component: UserGroupForm,
    },
];



// WEBPACK FOOTER //
// ./src/modules/user_group/router/user_group.js